import {
	Message
} from 'element-ui';
import clipboard from 'clipboard';

class Use {

	// 提示信息
	msg(message, type = 'info') {
		Message.closeAll()
		if (Boolean(message) === false) return;
		Message({
			message,
			type
		})
	}
	dateTimeInfo(dateTime) {
		let time = new Date(dateTime)
		let year = time.getFullYear()
		let month = time.getMonth() + 1
		let date = time.getDate()
		let hours = time.getHours()
		let minute = time.getMinutes()
		let second = time.getSeconds()

		if (month < 10) {
			month = '0' + month
		}
		if (date < 10) {
			date = '0' + date
		}
		if (hours < 10) {
			hours = '0' + hours
		}
		if (minute < 10) {
			minute = '0' + minute
		}
		if (second < 10) {
			second = '0' + second
		}
		return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
	}

	timeInfo(seconds) {
		let hours = Math.floor(seconds / 3600);
		let minutes = Math.floor((seconds % 3600) / 60);
		let remainingSeconds = seconds % 60;

		// 补零操作，确保每个时间单位至少是两位数
		hours = String(hours).padStart(2, '0');
		minutes = String(minutes).padStart(2, '0');
		remainingSeconds = String(remainingSeconds).padStart(2, '0');

		return `${hours}:${minutes}:${remainingSeconds}`;
	}

	// 将图片链接最后面得_s.jpg替换为_b.jpg
	replaceImageSuffix(url) {
		/**
		 * 替换URL中指定的后缀为新的后缀
		 * @param {string} url - 原始图片URL
		 * @return {string} 修改后的新URL
		 */
		return url.replace(/_s\.jpg$/, '_b.jpg');
	}


	desensitizeString(str) {
		// 如果字符串长度小于等于5，则直接返回相同长度的星号
		if (str.length <= 5) {
			return '*'.repeat(str.length);
		}
		// 否则，将前5位替换为星号，保留后面的字符
		return '*'.repeat(5) + str.slice(5);
	}


	// 格式化时间 年月日
	fromDate(time, type = '1', symbol = '-') {
		// type: 1年月日 2年月日时分秒 
		const date = new Date(time);
		// 使用 Date 对象提供的方法获取年、月、日
		const year = date.getFullYear();
		const month = date.getMonth() + 1; // JavaScript 中的月份是从 0 开始计数，所以需要加1
		const day = date.getDate();
		const hours = date.getHours();
		const minutes = date.getMinutes();
		const seconds = date.getSeconds();
		if (type == '1') {
			// 年月日
			return year + symbol + (month < 10 ? '0' + month : month) + symbol + (day < 10 ? '0' + day : day)
		} else if (type == '2') {
			// 年月日时分秒
			return year + symbol + (month < 10 ? '0' + month : month) + symbol + (day < 10 ? '0' + day : day) +
				' ' + (
					hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (
					seconds < 10 ? '0' + seconds : seconds)
		} else if (type == '3') {
			// 年月
			return year + symbol + (month < 10 ? '0' + month : month)
		}
	}

	// 格式化时间 年月日
	fromDate3(time, type = '1', symbol = '-') {
		// type: 1年月日 2年月日时分秒 
		const date = new Date(time);
		// 使用 Date 对象提供的方法获取年、月、日
		const year = date.getFullYear();
		const month = date.getMonth() + 1; // JavaScript 中的月份是从 0 开始计数，所以需要加1
		const day = date.getDate();
		const hours = date.getHours();
		const minutes = date.getMinutes();
		const seconds = date.getSeconds();
		if (type == '1') {
			// 年月日
			return (day < 10 ? '0' + day : day) + symbol + (month < 10 ? '0' + month : month) + symbol + year
		} else if (type == '2') {
			// 年月日时分秒
			return year + symbol + (month < 10 ? '0' + month : month) + symbol + (day < 10 ? '0' + day : day) +
				' ' + (
					hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (
					seconds < 10 ? '0' + seconds : seconds)
		} else if (type == '3') {
			// 年月
			return (month < 10 ? '0' + month : month) + symbol + year
		}
	}

	// 判断邮箱格式是否正确
	isValidEmail(email) {
		// 定义邮箱的正则表达式模式
		const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

		// 使用 RegExp 的 test 方法检查输入的邮箱是否匹配模式
		return emailPattern.test(email);
	}

	// 校验密码  密码要求至少8位字母+数值组合
	isValidPassword(password) {
		// 检查密码是否至少有8个字符，且仅包含字母和数字
		const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
		return regex.test(password);
	}

	isTenDigits(str) {
		const regex = /^\d{10}$/;
		return regex.test(str);
	}


	loading() {
		const loading = this.$loading({
			lock: true,
			text: 'Loading',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
		});
		setTimeout(() => {
			loading.close();
		}, 8000);
	}

	copy(text) {
		navigator.clipboard.writeText(text)
			.then(() => {
				this.msg('Copy successful.', 'success')
			})
			.catch(err => {
				console.error('Copy failed:', err);
				this.msg('Copy failed', 'error')
			});
	}
		// 生成唯一用户ID
	async getClientId() {
		// 随机数字id
		var random = Math.floor((Math.random() + Math.floor(Math.random() * 9 + 1)) * Math.pow(10, 10 - 1));
		// 时间戳
		var timeStamp = new Date().getTime();
		// clientID
		var clientId = `${random}.${timeStamp}`
		// 存储到缓存中
		return clientId
	}

	async sendGoogleEvent(event = 'lky7bet',) {
		// 测试环境  G-R58XCZ4BRM 生产环境  G-B7M08EMTNP
		const measurement_id = `G-B7M08EMTNP`;
		// 测试环境 WlUfUc8ZSbW3ngOVV4b6vQ 生产环境 O-yxdh-PTuiFx1LReQGMZA
		const api_secret = `O-yxdh-PTuiFx1LReQGMZA`;
		// 获取 clientId，这里假设存在一个 getClientId 函数
		var clientId = await this.getClientId()
		// 向google发送事件
		try {
			const response = await fetch(`https://www.google-analytics.com/mp/collect?measurement_id=${measurement_id}&api_secret=${api_secret}`, {
				method: "POST",
				body: JSON.stringify({
					client_id: clientId,
					events: [{
						// Event names must start with an alphabetic character.
						name: event,
						params: {
							"content_type": "product",
							"item_id": event
						}
					}]
				})
			});
		} catch (error) {
		}
	}








}

export default new Use()